var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragAndDropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9H5.5V12.085L4.205 10.795L3.5 11.5L6 14L8.5 11.5L7.795 10.795L6.5 12.085V9H12V8H0V9ZM3.5 2.5L4.205 3.205L5.5 1.915V5H0V6H12V5H6.5V1.915L7.795 3.205L8.5 2.5L6 0L3.5 2.5Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragAndDropIcon);
export default __webpack_public_path__ + "static/media/DragAndDropIcon.8f575a1bdbbabef0fb462a6870726d9f.svg";
export { ForwardRef as ReactComponent };